import { TransactionResponse, TransactionState } from '../models'

/**
 * SET INITIAL VALUES
 */
export const initialTransaction: TransactionResponse = {
  id: '',
  amount: 0,
  balanceAfter: 0,
  betId: 0,
  createdAt: '',
  currency: '',
  date: '',
  game: 0,
  gameName: '',
  gameCategory: 0,
  gameCategoryName: '',
  gameProvider: 0,
  gameProviderName: '',
  playerId: 0,
  transactionType: 0,
  updateAt: '',
  wallets: [],
  limit: 0,
  page: 0,
}

/**
 * SET INITIAL TRANSACTION STATE
 */
const initialState: TransactionState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  transactions: [],
  contributions: [],
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    page: 1,
    limit: 25,
  },
  contributionsFilters: { page: 1, limit: 25 },
}

export default initialState
